var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.list.title))]),_vm._v(" "),_c('span',{staticClass:"time color_gray"},[_c('span',{staticClass:"color-blue"},[_vm._v(_vm._s(_vm.list.author))]),_vm._v("   "+_vm._s(_vm.list.time))]),_vm._v(" "),_c('div',{staticClass:"detail-body",domProps:{"innerHTML":_vm._s(_vm.list.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-554f63b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/detail.vue
// module id = null
// module chunks = 